import * as React from 'react'

import './ButtonGroup.scss'

export interface IButtonGroupProps {
  /**
   * Custom className
   */
  className?: string
  /**
   * Remove vertical margin from top
   */
  noMargin?: boolean

  actionMargin?: boolean
  children: React.ReactNode
}

export class ButtonGroup extends React.PureComponent<IButtonGroupProps> {
  BEM = () => {
    const { className, noMargin, actionMargin } = this.props
    const classArray = ['button-group']

    if (className) {
      classArray.push(className)
    }

    if (noMargin) {
      classArray.push('button-group--no-margin')
    }

    if (actionMargin) {
      classArray.push('button-group--action-margin')
    }

    return classArray.join(' ')
  }

  render() {
    const { children } = this.props

    return <div className={this.BEM()}>{children}</div>
  }
}
